import { useState, useMemo } from "react";
import { Banknote } from "lucide-react";
import { monthlyPayment } from "@/lib/vehicles";

export function FinanceCalculator({ price }: { price: number }) {
  const [down, setDown] = useState(Math.round(price * 0.2));
  const [months, setMonths] = useState(84);
  const [rate, setRate] = useState(6.95);

  const monthly = useMemo(
    () => monthlyPayment(price, down, months, rate / 100),
    [price, down, months, rate],
  );

  const fmt = (n: number) => new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 }).format(n);

  return (
    <div className="rounded-3xl border border-border bg-card p-6">
      <div className="flex items-center gap-2">
        <Banknote size={18} className="text-accent" />
        <h3 className="font-display text-xl">Finansieringskalkylator</h3>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        Vägledande — vi hjälper dig till skarp offert från våra finanspartners.
      </p>

      <div className="mt-5 space-y-4 text-sm">
        <label className="block">
          <div className="flex justify-between">
            <span className="font-medium">Kontantinsats</span>
            <span className="tabular-nums">{fmt(down)} kr</span>
          </div>
          <input
            type="range"
            min={0}
            max={price}
            step={5000}
            value={down}
            onChange={(e) => setDown(Number(e.target.value))}
            className="mt-2 w-full"
          />
        </label>

        <label className="block">
          <div className="flex justify-between">
            <span className="font-medium">Löptid</span>
            <span className="tabular-nums">{months} mån</span>
          </div>
          <input
            type="range"
            min={12}
            max={120}
            step={12}
            value={months}
            onChange={(e) => setMonths(Number(e.target.value))}
            className="mt-2 w-full"
          />
        </label>

        <label className="block">
          <div className="flex justify-between">
            <span className="font-medium">Ränta</span>
            <span className="tabular-nums">{rate.toFixed(2)} %</span>
          </div>
          <input
            type="range"
            min={3}
            max={12}
            step={0.05}
            value={rate}
            onChange={(e) => setRate(Number(e.target.value))}
            className="mt-2 w-full"
          />
        </label>
      </div>

      <div className="mt-6 rounded-2xl bg-primary p-5 text-primary-foreground">
        <p className="text-xs uppercase tracking-wider opacity-80">Uppskattad månadskostnad</p>
        <p className="mt-1 font-display text-4xl tabular-nums">{fmt(monthly)} kr<span className="text-lg opacity-70">/mån</span></p>
      </div>
    </div>
  );
}
